module.exports = __webpack_public_path__ + "static/media/group_s_logo.bdcc8da7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/integrations_logos/group_s_logo.svg
// module id = 300
// module chunks = 0